var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"wrapper"},[_c('SvgIcone',{attrs:{"icone":_vm.funcionalidade.parametros.dashboard.icone,"width":64,"height":64,"cor":_vm.esquemaDeCor.aplicacao.corPrimariaAplicacao}}),_c('div',{staticClass:"text"},[_c('p',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('p',[_vm._v(" Tente mais tarde. ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }